import React from "../../../_snowpack/pkg/react.js";
const ButtonStep = (props) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "buttonStep",
    onClick: props.onClick || (() => {
    })
  }, /* @__PURE__ */ React.createElement("img", {
    src: props.imgSrc,
    alt: props.title
  }), /* @__PURE__ */ React.createElement("h2", null, props.title), /* @__PURE__ */ React.createElement("p", null, props.description));
};
export default ButtonStep;
